import { NgModule,CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { MsalGuard, MsalInterceptor, MsalBroadcastService, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration, MsalRedirectComponent } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';
import { HighchartsChartModule } from 'highcharts-angular';
import { SharedModule} from './shared/shared.module';
import { Router, RouterModule, RouteReuseStrategy } from '@angular/router';
import { NgxSpinnerModule } from "ngx-spinner";
import {  NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { RouterOutlet, RouterLink } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HeaderInterceptor } from './interceptors/header.interceptor';
import { CustomReuseStrategy } from './shared/services/route-reuse.strategy';
import { CarouselModule } from 'primeng/carousel';
import { NgxPermissionsModule } from 'ngx-permissions';
import "@maersk-global/mds-components-core/mc-tab-bar";
import '@maersk-global/mds-components-core/mc-tab';
import "@maersk-global/mds-components-core/mc-input";
import "@maersk-global/mds-components-core/mc-tag";
import "@maersk-global/mds-components-core/mc-pagination";
import "@maersk-global/mds-components-core/mc-select";
import "@maersk-global/mds-components-core/mc-option";
import "@maersk-global/mds-components-core/mc-input-date";
import "@maersk-global/mds-components-core/mc-checkbox";
import "@maersk-global/mds-components-core/mc-table";
import "@maersk-global/mds-components-core/mc-textarea";
import "@maersk-global/mds-components-core/mc-loading-indicator";
import "@maersk-global/mds-components-core/mc-toast";
import "@maersk-global/mds-components-core/mc-notification";
import "@maersk-global/mds-components-core/mc-menu";
import "@maersk-global/mds-components-core/mc-modal";
import "@maersk-global/mds-components-core/mc-button";
import "@maersk-global/mds-components-core/mc-multi-select";
import "@maersk-global/mds-components-core/mc-list";
import '@maersk-global/mds-components-core/mc-list-item';
import "@maersk-global/mds-components-core/mc-icon";
import "@maersk-global/mds-components-core/mc-card";
import '@maersk-global/mds-components-core/mc-typeahead';
import '@maersk-global/mds-components-core/mc-modal';
import '@maersk-global/mds-components-core-option';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import '@maersk-global/mds-components-core/mc-toast';
import '@maersk-global/mds-components-core/mc-button';
import '@maersk-global/mds-components-core/mc-notification';
import '@maersk-global/mds-components-core-avatar';
import "@maersk-global/mds-components-core/mc-multi-select";
import '@maersk-global/mds-components-core-typeahead';
import '@maersk-global/mds-components-core/mc-typeahead';
import { TableModule } from 'primeng/table';
import '@maersk-global/mds-components-core/mds-dev-utils'
import { MultiSelectModule } from 'primeng/multiselect';
import '@maersk-global/mds-components-core-popover';
import '@maersk-global/mds-components-core-button';
import { UnAthourisedComponent } from './un-athourised/un-athourised.component';
import { ProgressBarModule } from 'primeng/progressbar';
import { ToastModule } from 'primeng/toast';
export function loggerCallback(logLevel: LogLevel, message: string) {
  // console.log(message);
}


export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msalConfig.auth.clientId,
      authority: environment.msalConfig.auth.authority,
      redirectUri: '/inventory/ims-web/',
      postLogoutRedirectUri: '/inventory/ims-web/'
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage
    },
    system: {
      allowNativeBroker: false, // Disables WAM Broker
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  // protectedResourceMap.set(environment.apiConfig.uri, environment.apiConfig.scopes);
  protectedResourceMap.set(environment.baseUrl, [environment.apiConfig.scope]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return { 
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [...environment.apiConfig.scopes]
    },
    loginFailedRoute: '/login-failed'
  };
}


@NgModule({
  declarations: [
    AppComponent,
    UnAthourisedComponent
  ],
  imports: [
    BrowserModule,
    NoopAnimationsModule, // Animations cause delay which interfere with E2E tests
    AppRoutingModule,
    HttpClientModule,
    NgxSliderModule,
    MsalModule,
    NgxSpinnerModule,
    RouterModule,
    TableModule,
    MultiSelectModule,
    CarouselModule,
    ProgressBarModule,
    ToastModule,
    NgxPermissionsModule.forRoot()
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    {
      provide: RouteReuseStrategy,
      useClass: CustomReuseStrategy
    },
    // {
    //   provide: HTTP_INTERCEPTORS, 
    //   useClass: HeaderInterceptor, 
    //   multi: true
    // },
    MsalService,
    MsalGuard,
    MsalBroadcastService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule { }
